<form [formGroup]="shipToCustomerSearchForm">
  <div
    class="searchBox input-container"
    [ngStyle]="{
      border: !shipToCustomerSelected || shipToCustomerSearchForm.get('shipToCustomerSearch').invalid ? '1px solid red' : '',
      'border-radius': '4px'
    }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-search"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      />
    </svg>
    <input
      #searchBox
      [ngClass]="{ expanded: show }"
      [autofocus]="!disabled"
      type="text"
      [placeholder]="placeHolder"
      formControlName="shipToCustomerSearch"
      class="form-control"
      (focus)="isFocus($event)"
      (blur)="lostFocus($event)"
      (keyup)="onKeyboard($event)"
      aria-label="Search Customer"
    />
    <span class="loading-spinner" *ngIf="loading$ | async">
      <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
    </span>
  </div>

  <div *ngIf="show">
    <div
      #searchResult
      [ngClass]="forOrderHeader ? 'forOrderHeaderResult' : 'searchResult'"
    >
      <div style="max-height: 300px; overflow-y: auto">
        <table
          *ngIf="listOfCustomers?.length > 0"
          class="border my-4 table table-striped shadow-lg w-100"
        >
          <thead>
            <tr>
              <th scope="col" class="text-uppercase">
                Customer Name
              </th>
              <th scope="col" class="text-uppercase">
                EMAIL
              </th>
              <th scope="col" class="text-uppercase text-nowrap">
                FULL NAME
              </th>
              <th scope="col" class="text-uppercase text-nowrap">
                Customer Number
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let customer of shipToCustomer$ | async; let i = index"
              (click)="selectCustomer(customer)"
              [ngClass]="{ 'table-primary': i === indexFocus }"
            >
              <td>
                
                <ngb-highlight
                  [result]="customer.customerName"
                  [term]="shipToCustomerSearchForm.get('shipToCustomerSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customer.email"
                  [term]="shipToCustomerSearchForm.get('shipToCustomerSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customer.fullName"
                  [term]="shipToCustomerSearchForm.get('shipToCustomerSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customer?.parentCustomerNumber"
                  [term]="shipToCustomerSearchForm.get('shipToCustomerSearch').value"
                ></ngb-highlight>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
